import fetch from '../../rest/cards-move-after';

export default fetch;
